import Component from "@glimmer/component";
import DOverflowControls from "discourse/ui-kit/d-overflow-controls";
import type { DTabsTablistSignature } from "discourse/ui-kit/d-tabs/types";
import dRovingFocus from "discourse/ui-kit/modifiers/d-roving-focus";

/**
 * The tablist element: the keyboard surface and ARIA container the group's
 * tab buttons render into.
 *
 * It renders empty. The core portals the declaration block into it, so a
 * `<:header>` block can place it anywhere.
 *
 * The tablist role is withheld while no tab is registered, because an
 * empty tablist violates its required contents.
 */
export default class Tablist extends Component<DTabsTablistSignature> {
  get isVertical() {
    return this.args.tabs.orientation === "vertical";
  }

  <template>
    <DOverflowControls
      @axis={{@tabs.orientation}}
      @ownedScroller={{true}}
      @wrapperClass="d-tabs__strip-controls"
      as |strip|
    >
      {{! Splattributes come first so the role below stays authoritative. }}
      <div
        class="d-tabs__tablist"
        ...attributes
        aria-label={{if @tabs.hasTabs @tabs.label}}
        aria-orientation={{if (and @tabs.hasTabs this.isVertical) "vertical"}}
        role={{if @tabs.hasTabs "tablist"}}
        {{dRovingFocus
          orientation=@tabs.orientation
          itemSelector="[role='tab']"
          wrap=true
          itemsKey=@tabs.tabsVersion
          resetKey=@tabs.active
          tabStopAnchor="selection"
          disabledItems="focusable"
          onActivate=@tabs.activateFromElement
        }}
        {{@tabs.registerTablist}}
        {{strip.scroller}}
      ></div>
    </DOverflowControls>
  </template>
}
